export default __webpack_public_path__ + "static/media/icon-clock.8916de0e.svg";